import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import Expensedetailmodal from "./expensedetailmodal";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";

const Expensetable = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

    const [expense,setexpense]=useState();
    const [show,setshow]=useState(false);
  return (
    <div>
        <Expensedetailmodal show={show} setshow={setshow} expense={expense} />
        <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
        
        {/* Section Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <h2 className="text-base font-semibold text-slate-800">لیستی خەرجییەکان</h2>
        </div>

        {/* Table */}
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-100">
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              جۆری خەرجی
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              بڕی خەرجکراو
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
              {initState.expense_report.map((lis)=>(
              <tr key={lis.expense_type_id} className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer" onClick={()=>{setexpense(lis.expense);setshow(true)}}>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                  {lis.expense_type_name}
                </td>
                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                    {numberbeautify(iqd_rounding(money_rounding(lis.expense.reduce((a, v) => a = Number(a) + Number(v.expense_amount), 0))))} IQD
                </td>
              </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Expensetable